import { FC, RefObject } from 'react';
import Slider from 'react-slick';
import withErrorBoundary from 'components/shared/withErrorBoundary';
import { RoomClass } from 'ts/hotel/interfaces/HotelDetails';

interface RoomDetailsSliderProps {
  choosenRoom: RoomClass | undefined;
  nav1: Slider | null;
  nav2: Slider | null;
  slider1: RefObject<Slider>;
  slider2: RefObject<Slider>;
}

const RoomDetailsSlider: FC<RoomDetailsSliderProps> = ({
  choosenRoom,
  nav1,
  nav2,
  slider1,
  slider2,
}) => {
  const supliments = choosenRoom?.hotelRooms[0].suppliments?.filter((sup) => sup.type === 'I');

  const responsiveConfigHorizontal = [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
      },
    },
  ];

  if (!supliments?.length) {
    return null;
  }

  if (window.innerWidth > 768) {
    return (
      <div style={{ display: 'flex', gap: '15px', marginTop: '20px', marginBottom: '20px' }}>
        <div style={{ flex: '1', minWidth: 0 }}>
          <div className="hotel-result-settings-img hotel-result-f-w">
            <Slider asNavFor={nav2 || undefined} ref={slider1} arrows dots={false}>
              {supliments.map((sup, index) => (
                <div className="hotel-result-settings-slide" key={index}>
                  <img src={sup.desc} alt={'room' + index} />
                </div>
              ))}
            </Slider>
          </div>
        </div>
        <div style={{ width: '170px', height: '400px', flexShrink: 0 }}>
          <Slider
            asNavFor={nav1 || undefined}
            ref={slider2}
            slidesToShow={Math.min(4, supliments.length || 1)}
            slidesToScroll={1}
            focusOnSelect
            arrows={false}
            centerMode={false}
            swipeToSlide
            vertical
            verticalSwiping
          >
            {supliments.map((sup, index) => (
              <div key={index} style={{ padding: '5px 0' }}>
                <div
                  style={{
                    cursor: 'pointer',
                    border: '2px solid transparent',
                    borderRadius: '5px',
                    overflow: 'hidden',
                    transition: 'border-color 0.3s',
                  }}
                  className="thumbnail-slide"
                >
                  <img
                    src={sup.desc}
                    alt={'thumbnail' + index}
                    style={{
                      width: '100%',
                      height: '91px',
                      objectFit: 'cover',
                      display: 'block',
                    }}
                  />
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="hotel-result-settings-img hotel-result-f-w mt-20">
        <Slider asNavFor={nav2 || undefined} ref={slider1} arrows dots={false}>
          {supliments.map((sup, index) => (
            <div className="hotel-result-settings-slide" key={index}>
              <img src={sup.desc} alt={'room' + index} />
            </div>
          ))}
        </Slider>
      </div>
      <div className="mb-20">
        <Slider
          asNavFor={nav1 || undefined}
          ref={slider2}
          slidesToShow={Math.min(4, supliments.length || 1)}
          slidesToScroll={1}
          focusOnSelect
          arrows={false}
          centerMode={false}
          swipeToSlide
          responsive={responsiveConfigHorizontal}
        >
          {supliments.map((sup, index) => (
            <div key={index} style={{ padding: '0 5px' }}>
              <div
                style={{
                  cursor: 'pointer',
                  border: '2px solid transparent',
                  borderRadius: '5px',
                  overflow: 'hidden',
                  transition: 'border-color 0.3s',
                }}
                className="thumbnail-slide"
              >
                <img
                  src={sup.desc}
                  alt={'thumbnail' + index}
                  style={{
                    width: '100%',
                    height: '120px',
                    objectFit: 'cover',
                    display: 'block',
                  }}
                />
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </>
  );
};

export default withErrorBoundary(RoomDetailsSlider, 'RoomDetailsSlider');
